<script setup lang="ts">
import {ref} from 'vue'

const props = defineProps({
  text: String,
  size: {
    type: String,
    default() {
      return 'md'
    }
  },
  color: {
    type: String,
    default() {
      return 'primary'
    }
  },
  textColor: {
    type: String,
    default() {
      return 'white'
    }
  },
  to: String,
  icon: String
});
const fontSize = computed(() => {
  return props.size == 'sm' ? '12' : '16';
});
const classList = computed(() => {
  let classes = ['icon-button', 'text-' + props.textColor];
  if(props.size == 'sm') {
    classes.push('px-2');
    classes.push('py-1');
  } else {
    classes.push('px-3');
    classes.push('py-2');
  }
  return classes;
});
</script>

<template>
  <v-btn :size="size" rounded="lg" :style="{fontSize : fontSize+'px'}" variant="flat" :color="color" :to="to" :class="classList">{{ text }}
    <v-icon v-if="icon" :color="textColor" :size="fontSize" :icon="icon"></v-icon>
  </v-btn>
</template>
